import { BsArrowLeft, BsTrash2 } from "react-icons/bs";
import { Button } from "../../../pages/helpCenter";
import { BiCalendar, BiPencil, BiSolidDislike, BiSolidLike } from "react-icons/bi";
import { useEffect, useRef } from "react";

const ArticleContent = ({ html }) => {
  const containerRef = useRef(null);

  useEffect(() => {
    const el = containerRef.current;
    if (!el) return;

    const content = html || "<p class='text-slate-400'>No content yet.</p>";

    if ("setHTML" in el) {
      el.setHTML(content, {
        sanitizer: new window.Sanitizer({
          allowElements: [
            "p", "h2", "h3", "ul", "ol", "li", "blockquote", "pre", "code",
            "strong", "em", "img", "a", "br", "span"
          ],
          allowAttributes: {
            "img": ["src", "alt", "width", "height"],
            "a": ["href", "target", "rel"],
          },
        }),
      });
    } else {
      el.innerHTML = content;
    }
  }, [html]);

  return (
    <div
      ref={containerRef}
      className="prose prose-sm max-w-none text-sm leading-relaxed text-slate-700 [&_h2]:font-serif [&_h2]:text-xl [&_h2]:font-semibold [&_h2]:text-slate-900 [&_h2]:mt-5 [&_h2]:mb-2 [&_h3]:font-serif [&_h3]:text-lg [&_h3]:font-semibold [&_h3]:text-slate-900 [&_h3]:mt-4 [&_h3]:mb-2 [&_ul]:list-disc [&_ul]:pl-5 [&_ul]:space-y-1 [&_ol]:list-decimal [&_ol]:pl-5 [&_ol]:space-y-1 [&_blockquote]:border-l-2 [&_blockquote]:border-cyan-600 [&_blockquote]:pl-3 [&_blockquote]:text-slate-500 [&_blockquote]:italic [&_pre]:bg-slate-900 [&_pre]:text-slate-100 [&_pre]:rounded-lg [&_pre]:p-4 [&_pre]:text-xs [&_pre]:overflow-x-auto [&_strong]:text-slate-900 [&_p]:mb-2 [&_img]:max-w-full [&_img]:rounded-xl [&_img]:my-4 [&_a]:text-cyan-700 [&_a]:underline"
    />
  );
};
export const ArticleDetail = ({ article, category, subcategory, onEdit, onDelete, onBack }) => {
  return (
    <div className="mx-auto max-w-3xl px-6 py-8 sm:px-10">
      <button type="button" onClick={onBack} className="mb-4 inline-flex items-center gap-1 text-xs font-medium text-slate-400 hover:text-slate-700">
        <BsArrowLeft size={13} /> {subcategory ? subcategory.name : category?.name}
      </button>

      <div className="mb-1 flex items-center gap-2">
        <span className="h-2 w-2 rounded-full"/>
        <span className="text-xs font-medium text-slate-400">
          {category?.name}
          {subcategory ? ` / ${subcategory.name}` : ""}
        </span>
      </div>

      <div className="mb-6 flex items-start justify-between gap-4">
        <div>
          <h1 className="font-serif text-2xl font-bold text-slate-900 sm:text-3xl">{article.title}</h1>
          {article.description && <p className="mt-2 text-sm text-slate-500">{article.description}</p>}
          <div className="mt-3 flex items-center gap-3 text-xs text-slate-400">
            <span className="flex items-center gap-1.5">
              <BiCalendar size={13} />
              Created {article.createdAt ? new Date(article.createdAt).toLocaleDateString(undefined, { year: "numeric", month: "long", day: "numeric" }) : "Recently"}
            </span>
            <span className="text-slate-300">·</span>
            <span className="flex items-center gap-1 text-emerald-600">
              <BiSolidLike size={13} />
              {article.helpfulCount ?? 0}
            </span>
            <span className="flex items-center gap-1 text-rose-500">
              <BiSolidDislike size={13} />
              {article.notHelpfulCount ?? 0}
            </span>
          </div>
        </div>
        <div className="flex shrink-0 gap-2">
          <Button variant="secondary" size="sm" onClick={onEdit}>
            <BiPencil size={14} /> Edit
          </Button>
          <Button variant="dangerGhost" size="sm" onClick={onDelete}>
            <BsTrash2 size={14} /> Delete
          </Button>
        </div>
      </div>

      <div className="rounded-2xl border border-slate-200 bg-white p-6 sm:p-8">
        <ArticleContent html={article.content} />
      </div>
    </div>
  );
}